import { useEffect } from 'react'

import loadable from '@loadable/component'
import { Redirect, Route, Switch } from 'react-router'

import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons'

import { AppInitialProps } from './@types'
import { useLogout } from './hooks/useLogout'
import { SlateApp } from './SlateApp'

const Admin = loadable(() => import('./components/Admin'), {
  resolveComponent: components => components.Admin,
})

const PostEmbed = loadable(() => import('./embed/Post'), {
  resolveComponent: module => module.PostEmbed,
})

const SpaceEmbed = loadable(() => import('./embed/Space'), {
  resolveComponent: module => module.SpaceEmbed,
})

const Unsubscribe = loadable(
  () => import('./components/Settings/Unsubscribe'),
  {
    resolveComponent: module => module.Unsubscribe,
  },
)

const DownloadMembers = loadable(
  () => import('./components/Admin/Members/DownloadMembers'),
  {
    resolveComponent: module => module.DownloadMembers,
  },
)

const Logout = () => {
  const { logout } = useLogout()
  useEffect(() => {
    logout()
  }, [])

  return (
    <div className="flex items-center justify-center h-screen w-screen">
      <SpinnerIcon className="animate-spin h-7 w-7" />
    </div>
  )
}

export const Routes = ({ pageProps }: { pageProps: AppInitialProps }) => (
  <Switch>
    <Route path="/admin">
      <Redirect to="/manage/people/members" />
    </Route>
    <Route path="/manage/people/members/export/:id">
      <DownloadMembers />
    </Route>
    <Route path="/manage">
      <Admin />
    </Route>
    <Route path="/auth/logout">
      <Logout />
    </Route>
    <Route exact path="/embed/post/:id">
      <PostEmbed />
    </Route>
    <Route exact path="/embed/space/:slug">
      <SpaceEmbed />
    </Route>
    <Route path="/settings/notifications/unsubscribe" exact>
      <Unsubscribe />
    </Route>
    <Route>
      <SlateApp pageProps={pageProps} />
    </Route>
  </Switch>
)
